/* TAPORA: apariciones, galería, selector de diseño y barra de compra fija */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.tp-reveal:not(.tp-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('tp-in'); }); return; }
    var vh = window.innerHeight;
    els.forEach(function (e) { if (e.getBoundingClientRect().top < vh * 0.95) e.classList.add('tp-in'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('tp-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (e) { if (!e.classList.contains('tp-in')) io.observe(e); });
  }

  function setMain(gal, src) {
    var main = gal && gal.querySelector('[data-tp-main]');
    if (!main || !src || main.getAttribute('src') === src) return;
    main.style.opacity = 0;
    setTimeout(function () { main.src = src; main.style.opacity = 1; }, 160);
    gal.querySelectorAll('[data-tp-thumb]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-tp-thumb') === src); });
  }

  function initGallery(root) {
    (root || document).querySelectorAll('[data-tp-gallery]').forEach(function (g) {
      g.querySelectorAll('[data-tp-thumb]').forEach(function (b) {
        b.addEventListener('click', function () { setMain(g, b.getAttribute('data-tp-thumb')); });
      });
    });
  }

  function initBuy(root) {
    (root || document).querySelectorAll('[data-tp-buy]').forEach(function (box) {
      var form = box.querySelector('form');
      var data = box.querySelector('[data-tp-variants]');
      if (!form || !data) return;
      var variants = JSON.parse(data.textContent);
      var idInput = form.querySelector('input[name="id"]');
      var price = box.querySelector('[data-tp-price]');
      var btn = form.querySelector('button[type="submit"]');
      var gal = box.querySelector('[data-tp-gallery]');
      var groups = box.querySelectorAll('[data-tp-option]');
      var pers = box.querySelector('[data-tp-pers]');
      // Tarjeta NFC: el logo y las notas solo se piden con la opción de diseño personalizado
      function syncPers(sel) {
        if (!pers) return;
        var custom = (pers.getAttribute('data-custom') || '').trim().toLowerCase();
        var isCustom = !!custom && sel.some(function (o) { return (o || '').trim().toLowerCase() === custom; });
        var wifiList = (pers.getAttribute('data-wifi') || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
        var isWifi = sel.some(function (o) { return wifiList.indexOf((o || '').trim().toLowerCase()) > -1; });
        var show = function (selector, on) {
          pers.querySelectorAll(selector).forEach(function (el) {
            el.hidden = !on;
            el.querySelectorAll('input, textarea, select').forEach(function (i) { i.disabled = !on; });
          });
        };
        show('[data-tp-custom]', isCustom);
        var socialList = (pers.getAttribute('data-social') || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
        var isSocial = sel.some(function (o) { return socialList.indexOf((o || '').trim().toLowerCase()) > -1; });
        show('[data-tp-wifi]', isWifi);
        show('[data-tp-social]', isSocial);
        show('[data-tp-linkwrap]', !isWifi && !isSocial);
        show('[data-tp-color]', isWifi || isSocial || isCustom);
        syncPass();
      }
      // Wi-Fi sin contraseña: se oculta el campo de contraseña
      function syncPass() {
        if (!pers) return;
        var sec = pers.querySelector('[data-tp-sec]'), wrap = pers.querySelector('[data-tp-passwrap]');
        if (!sec || !wrap) return;
        var open = !sec.disabled && sec.value === 'No password';
        if (sec.disabled) return;
        wrap.hidden = open;
        wrap.querySelectorAll('input').forEach(function (i) { i.disabled = open; });
      }
      function chosen() {
        return Array.prototype.map.call(groups, function (g) {
          if (g.tagName === 'INPUT') return g.value;
          var c = g.querySelector('input:checked'); return c ? c.value : null;
        });
      }
      function update() {
        var sel = chosen();
        syncPers(sel);
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        box.querySelectorAll('[data-tp-current]').forEach(function (s) { var i = +s.getAttribute('data-tp-current'); s.textContent = sel[i] || ''; });
        if (!v) { btn.disabled = true; btn.querySelector('span').textContent = btn.getAttribute('data-na'); return; }
        idInput.value = v.id;
        if (price) price.innerHTML = v.price_html;
        btn.disabled = !v.available;
        btn.querySelector('span').textContent = v.available ? btn.getAttribute('data-add') : btn.getAttribute('data-soldout');
        if (v.image) setMain(gal, v.image);
        document.querySelectorAll('[data-tp-sticky-price]').forEach(function (p) { p.innerHTML = v.price_plain; });
        if (window.history && window.history.replaceState && box.hasAttribute('data-tp-main-product')) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      }
      box.addEventListener('change', function (e) { if (e.target.closest('[data-tp-option]')) update(); });
      if (pers) {
        syncPers(chosen());
        var link = pers.querySelector('[data-tp-link]');
        var err = pers.querySelector('[data-tp-err]');
        var fixLink = function () { var v = link.value.trim(); if (v && !/^https?:\/\//i.test(v)) link.value = 'https://' + v; return link.value.trim(); };
        if (link) link.addEventListener('blur', fixLink);
        var secSel = pers.querySelector('[data-tp-sec]');
        if (secSel) secSel.addEventListener('change', syncPass);
        form.addEventListener('submit', function (e) {
          var msg = '';
          var name = pers.querySelector('input[name="properties[Business name]"]');
          if (name && !name.value.trim()) msg = pers.getAttribute('data-msg-required');
          var ssid = pers.querySelector('[data-tp-ssid]');
          if (!msg && ssid && !ssid.disabled && !ssid.value.trim()) msg = pers.getAttribute('data-msg-ssid');
          var pass = pers.querySelector('[data-tp-pass]');
          if (!msg && pass && !pass.disabled) {
            var sv = (pers.querySelector('[data-tp-sec]') || {}).value;
            var pv = pass.value;
            if (!pv || (sv === 'WPA/WPA2/WPA3' && pv.length < 8)) msg = pers.getAttribute('data-msg-pass');
          }
          var plink = pers.querySelector('[data-tp-plink]');
          if (!msg && plink && !plink.disabled) {
            var pv2 = plink.value.trim();
            if (pv2 && !/^https?:\/\//i.test(pv2)) { pv2 = 'https://' + pv2; plink.value = pv2; }
            if (!pv2 || !/^https?:\/\/[^\s\/.]+\.[^\s]{2,}/i.test(pv2)) msg = pers.getAttribute('data-msg-profile');
          }
          if (!msg && link && !link.disabled) {
            var lv = fixLink();
            if ((link.hasAttribute('data-tp-req') && !lv) || (lv && !/^https?:\/\/[^\s\/.]+\.[^\s]{2,}/i.test(lv))) msg = pers.getAttribute('data-msg-link');
          }
          var logo = pers.querySelector('[data-tp-logo]');
          if (!msg && logo && !logo.disabled && !(logo.files && logo.files.length)) msg = pers.getAttribute('data-msg-logo');
          if (msg) {
            e.preventDefault();
            err.textContent = msg; err.hidden = false;
            err.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
          } else if (err) { err.hidden = true; }
        });
      }
      var q = form.querySelector('input[name="quantity"]');
      box.querySelectorAll('[data-tp-qty]').forEach(function (b) {
        b.addEventListener('click', function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-tp-qty'), 10)); });
      });
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-tp-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var isProduct = !!document.querySelector('[data-tp-main-product]');
    var row = document.querySelector('.tp-buy__row');
    var ends = document.querySelectorAll('.tp-cta__box, .footer, footer');
    var rowVisible = false, endVisible = 0;
    if (row) new IntersectionObserver(function (en) { en.forEach(function (e) { rowVisible = e.isIntersecting; }); toggle(); }).observe(row);
    var endIO = new IntersectionObserver(function (en) { en.forEach(function (e) { endVisible += e.isIntersecting ? 1 : -1; if (endVisible < 0) endVisible = 0; }); toggle(); });
    ends.forEach(function (e) { endIO.observe(e); });
    function toggle() {
      var show = !rowVisible && endVisible === 0 && (isProduct || window.scrollY > 520);
      bar.classList.toggle('is-on', show);
    }
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  }

  function init(root) { initReveal(root); initGallery(root); initBuy(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initSticky(); }); else { init(); initSticky(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); initSticky(); });
})();
